import { damageRouter } from './router'

export { damageRouter }
